import {useTutorialTrackerContext} from '@contexts/tutorialTrackerContext';

/**
 * Estado global de tutoriales por módulo (catálogo en @constants/tutorialModules).
 *
 * @example
 * const { tutoriales, cargando, marcarComoCompletado } = useTutorialTracker();
 *
 * useEffect(() => {
 *   if (!cargando && tutoriales?.['movements-incomes'] === false) {
 *     iniciarTutorialMovimientos();
 *   }
 * }, [cargando, tutoriales]);
 *
 * // Al finalizar el tour:
 * marcarComoCompletado('movements-incomes');
 */
const useTutorialTracker = () => useTutorialTrackerContext();

export default useTutorialTracker;
